import React from 'react'
import { Button, Icon } from 'antd'
import { useTranslation } from 'react-i18next'

const CustomPagination = ({
  currentPage,
  totalPages,
  onPageChange,
  loading
}) => {
  const { t } = useTranslation()
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px 0'
      }}
    >
      <Button
        style={{ borderRadius: '8px' }}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1 || loading}
      >
        <Icon type="left" />
        {t('v5:previous')}
      </Button>
      <span style={{ margin: '0 15px', color: '#000' }}>
        {`${t('general:page')} ${currentPage} of ${totalPages}`}
      </span>
      <Button
        style={{ borderRadius: '8px' }}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages || loading}
      >
        {t('buttons:next')} <Icon type="right" />
      </Button>
    </div>
  )
}

export default CustomPagination
